import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const LinkUploadMedia = () => {
    // context
    const {
        linkMedia,
        setLinkMedia,
        linkCover,
        setLinkCover,
        setLinkCoverId,
        linkMediaId,
        setLinkMediaId,
        linkCoverId,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        setLinkCoverId(linkCover[0] ? linkCover[0]?._id : null);
        const ids = [];
        const files = [];
        linkMedia.map((file) => {
            ids.push(file._id);
            files.push({
                uid: file._id,
                name: `${file.type}/${file._id}`,
                status: "done",
                url: file.address,
            });
        });
        setLinkMediaId(ids);
        setLinkMedia(files);
        setLinkCover([
            {
                uid: linkCoverId,
                name: "image.png",
                status: "done",
                url: linkCover[0]?.address,
            },
        ]);
    }, []);
    // upload
    const onChangeCover = (info) => {
        setLinkCover(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setLinkCoverId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onChange = (info) => {
        setLinkMedia(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setLinkMediaId([...linkMediaId, file._id]);
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = linkMedia.filter((file) => file !== info);
        const newIds = linkMediaId.filter((id) => id !== info.uid);
        setLinkMediaId(newIds);
        setLinkMedia(newFiles);
    };
    console.log(linkCoverId, linkMediaId);
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
                gap: "2rem",
            }}
        >
            <ImgCrop modalTitle="ویرایش عکس" aspect={2} rotationSlider>
                <Upload
                    maxCount={1}
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ae13e9106040ff0e09e2e5`}
                    listType="picture-card"
                    fileList={linkCover}
                    onChange={onChangeCover}
                    onPreview={onPreview}
                >
                    {linkCover?.length < 5 && "+ آپلود عکس کاور"}
                </Upload>
            </ImgCrop>
            <ImgCrop modalTitle="ویرایش عکس" rotationSlider>
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ae13d9106040ff0e09e2c9`}
                    listType="picture-card"
                    fileList={linkMedia}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {linkCover?.length < 3 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ae13d9106040ff0e09e2c9`}
                listType="picture-card"
                fileList={linkMedia}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {linkCover?.length < 3 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {linkMedia.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default LinkUploadMedia;
